var blogAuthorEl = document.getElementById('blogAuthor');
var blogName = blogAuthor.getAttribute('data-blog-name');
var blogLink = blogAuthor.getAttribute('data-blog-link');

var guestAuthorHolder = document.getElementById('guestAuthor');

var createHref = function() {
    var hrefEl = document.createElement('a');
    var hreftText = document.createTextNode(blogName);
    hrefEl.appendChild(hreftText);
    hrefEl.title = blogName;
    hrefEl.href = "http://" + blogLink;
    hrefEl.target = "_blank";
    guestAuthorHolder.appendChild(hrefEl);
}

var showAuthor = function() {
    guestAuthorHolder.style.display ="block";
}


if (blogName) {
    createHref();
    showAuthor();
}


